var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#667085"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 5.75,
    stroke: "white",
    strokeWidth: 2,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8 L7 11 L12 5",
    stroke: "white",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFilled);
export default __webpack_public_path__ + "static/media/check_filled.594134b7ec0763ef4a6ac5319ee780f6.svg";
export { ForwardRef as ReactComponent };